import { reactive } from 'vue'

export type SiteSettings = { language:string; site_name:string; company_info:string; timezone:string; revision:number }
// Public presentation metadata only: no user, tenant or credentials are cached.
export const siteSettings = reactive<SiteSettings>({ language:'zh-CN',site_name:'Nexus DCIM',company_info:'',timezone:'Asia/Shanghai',revision:0 })
